<template>
    <div>
        <h2 class="title has-text-centered">
            Mes informations
        </h2>

        <section class="section" id="my-informations-form">
            <div class="box form-fields">
                <div class="field" v-for="(field, index) in fields" :key="index">
                    <label class="label">{{field.name}} <span v-if="field.required">*</span> </label>
                    <div class="control">
                        <input
                            class="input"
                            @input="formatPhone"
                            type="tel"
                            maxlength="14"
                            :placeholder="field.description??''"
                            :data-efs-id="field.efs_id"
                            v-if="field.data_type === 'telephone'"
                            :id="`field-${field.internal_col_name}`"
                            :value="getFieldValue(field)"
                            :data-default-value="getFieldValue(field)"
                            :field_name="field.internal_col_name"
                        >
                        <input
                            class="input"
                            :type= "field.data_type"
                            :data-efs-id="field.efs_id"
                            :placeholder="field.description ?? ''"
                            v-else-if="field.data_type === 'number'"
                            :id="`field-${field.internal_col_name}`"
                            :value="getFieldValue(field)"
                            :data-default-value="getFieldValue(field)"
                            :field_name="field.internal_col_name"
                            min="0"
                        />
                        <input
                            class="input"
                            :type="field.data_type"
                            :data-efs-id="field.efs_id"
                            :placeholder="field.description??''"
                            v-else-if="['text', 'email', 'date'].includes(field.data_type)"
                            :id="`field-${field.internal_col_name}`"
                            :value="getFieldValue(field)"
                            :data-default-value="getFieldValue(field)"
                            :field_name="field.internal_col_name"
                        >
                        <textarea
                            v-else-if="field.data_type === 'textarea'"
                            name=""
                            class="textarea"
                            :id="`field-${field.internal_col_name}`"
                            :placeholder="field.description??''"
                            :value="getFieldValue(field)"
                            :field_name="field.internal_col_name"
                        ></textarea>
                        <div class="select"
                            v-if="field.data_type === 'select'"
                        >
                            <select name=""
                                :id="`field-${field.internal_col_name}`"
                                :value="getFieldValue(field)"
                                :field_name="field.internal_col_name">
                                <option v-for="(option, index) in field.options" :key="index" :value="option.value">{{option.label}}</option>
                            </select>
                        </div>

                        <div v-else-if="field.data_type === 'checkbox'" :id="`field-${field.internal_col_name}`">
                            <div v-for="(option, index) in field.options" :key="index">
                                <label :for="`option-${field.efs_is}-${option.value}`" class="checkbox" >
                                    <input
                                        type="checkbox"
                                        :name="field.internal_col_name"
                                        :id="`option-${field.efs_is}-${option.value}`"
                                        :value="option.value"
                                        :field_name="field.internal_col_name"
                                        :checked="getIsChecked(field, option.value)"
                                    >
                                    {{option.label}}
                                </label>
                            </div>

                        </div>
                    </div>
                </div>
                <p class="help is-large">Les champs marqués d'un * sont obligatoires.</p>
                <br>
                <div class="buttons is-flex is-justify-content-center">
                    <button id="btn-save"
                        :class="is_loading ? 'button is-loading is-rounded is-info' : 'button is-rounded is-info'"
                        @click="save">
                        Sauvegarder
                    </button>
                    <button id="btn-delete" class="button is-rounded is-info" style="background-color: #df4e4e;" @click="showDeleteAccount">Supprimer</button>
                </div>
                <p class="help is-danger is-size-6">
                    {{error_message}}
                </p>
            </div>
        </section>
        <div class="modal" id="delete-account-modal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                <p class="modal-card-title">Confirmer la suppression du compte</p>
                <button class="delete" @click="hideDeleteAccount()" aria-label="close"></button>
                </header>
                <section class="modal-card-body">
                    <div class="is-flex is-justify-content-center">
                        <div>
                            <p class="help is-danger is-size-5_5">Veuillez noter que tous vos rendez-vous à venir seront annulés !</p>
                            <p>Etes vous certain de vouloir Supprimer ce compte ?</p>
                        </div>
                    </div>
                    <div class="buttons is-justify-content-flex-end pt-3">
                        <button class="button is-info" @click="printFields">Confirmer</button>
                        <button class="button" @click="hideDeleteAccount()">Annuler</button>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { Inertia } from '@inertiajs/inertia'
import {toast} from 'bulma-toast'
export default {
    name: 'MesInformations',
    computed : {
        user() {
            return this.$page.props.auth.user?.client?.[0]
        },
    },
    data () {
        return {
            error_message: null,
            fields: [],
            is_loading: false
        }
    },
    methods : {
        printFields() {
            console.log(this.fields)
        },
        formatPhone(ev){
            let input = ev.target;
            let digits =  ev.target.value.replaceAll(/[^0-9]/g,'')?.match(/.{1,2}/g)?.join('.') ?? '';
            input.value = digits;
        },
        isDateSupported() {
            let input = document.createElement('input');
            let value = 'a';
            input.setAttribute('type', 'date');
            input.setAttribute('value', value);
            return input.value !== value;

        },
        getFields () {
            axios.get('/client/informations').then(response => {
                this.fields = response.data.fields.sort((a, b) => a.position - b.position)
            })
        },
        getFieldValue (field) {
            let value = this.user[field.internal_col_name] ?? '';
            if(field.data_type === 'date' && this.isDateSupported()){
                value = value.split('/').reverse().join('-');
            }
            return value;
        },
        getIsChecked (field, option) {
            if (!this.user[field.internal_col_name]) return false
            return this.user[field.internal_col_name].split(',').includes(option)
        },
        hideDeleteAccount () {
            let modal = document.querySelector('#delete-account-modal')
            modal.classList.remove('is-active')
            this.rdvToCancel = null
        },
        showDeleteAccount(rdv) {
            let modal = document.querySelector('#delete-account-modal')
            modal.classList.add('is-active')
            this.rdvToCancel = rdv.rdv_id
        },
        save () {
            let fields = document.querySelectorAll('.form-fields [field_name]')
            let data = {}
            for (let field of fields) {
                if (field.getAttribute('type') === 'checkbox' && !field.checked) continue
                let field_name = field.getAttribute('field_name')
                let elt = data[field_name] || []
                if (field.value || field.getAttribute('value')) elt.push(field.value || field.getAttribute('value'))
                data[field_name] = elt
                // console.log(field)
                // console.log(field.value || field.getAttribute('value'))
            }
            // console.log(data)
            for (let key in data) {
                let field = this.fields.find(field => field.internal_col_name === key)
                if (field.data_type !== "checkbox") data[key] = data[key].toString()
                if (field.required && !data[key]) {
                    let field_name = field.name ? field.name?.toLowerCase() : null
                    this.error_message =
                        field_name ?
                        `Le champ "${field_name}" est obligatoire.` :
                        "Merci de renseigner tous les champs obligatoires."
                    return false
                }
                if(field.data_type === 'date'){
                    let result = /^(\d{4})-(\d{2})-(\d{2})$/.exec(data[key]);
                    if (result){
                        data[key] = `${result[3]}/${result[2]}/${result[1]}`
                    }else if(/^\d{2}\/\d{2}\/\d{4}$/.test(data[key])){
                    }else{
                        let field_name = field.name.toLowerCase()
                        this.error_message =  `Le champ "${field_name}" doit être une date valide.`
                        return false
                    }
                }
                if (field.data_type === "number" && data[key]) {
                    let numberValue = Number(data[key].replace(/,/g, '.'));
                    let field_name = field.name?.toLowerCase() || key;
                    const configKey = `MAX_LIMITE-${field.efs_id}`;
                    let maxValue = this.config?.[configKey];
                    if (isNaN(numberValue) || numberValue < 0) {
                        toast({
                            message: `Le champ "${field_name}" doit être un nombre positif.`,
                            type: 'is-danger',
                            duration: 5000,
                            pauseOnHover: true
                        })
                        return false;
                    }
                    if (field.internal_col_name !== "zipcode" && numberValue > maxValue) {
                        toast({
                                message: `Le champ "${field_name}" doit être inférieur à "${maxValue}".`,
                                type: 'is-danger',
                                duration: 5000,
                                pauseOnHover: true
                        })
                        return false;
                    }
                    data[key] = numberValue;
                }
            }
            
            this.error_message = null
            this.is_loading = true
            axios.post('modify_client', data).then(response => {
                Inertia.reload({ only: ['auth.user'] })
                this.is_loading = false
                toast({
                        message: response?.data?.message || 'Vos changements ont bien été pris en compte.',
                        type: 'is-success',
                        duration: 3000,
                        pauseOnHover: true
                    })
            }).catch(err => {
                if (err?.response?.data?.errors) {
                    for (let error in err?.response?.data?.errors) {
                        err.response.data.errors[error].forEach(message => {
                            toast({
                                message: message,
                                type: 'is-danger',
                                duration: 5000,
                                pauseOnHover: true
                            })
                        });
                    }
                } else {
                    toast({
                        message: 'Vos changements n\'ont pas pu être pris en compte.',
                        type: 'is-danger',
                        duration: 5000,
                        pauseOnHover: true
                    })
                }
                this.is_loading = false
            })
        },
        deleteAccount () {
            axios.delete('/account').then(response => {
                if(response.status == 200){
                    toast({
                        message: 'Le compte a été supprimé avec succès.',
                        type: 'is-success',
                        duration: 3000,
                        pauseOnHover: true
                    })
                    this.$inertia.get("/");

                }else{
                    toast({
                        message: 'Erreur lors de la suppression du compte.',
                        type: 'is-danger',
                        duration: 3000,
                        pauseOnHover: true
                    })
                }
            });
        },
    },
    mounted () {
        this.getFields()
    }
}
</script>


<style>
#my-informations-form .datetimepicker-dummy .datetimepicker-dummy-wrapper {
    border-radius: 4px !important;
}

#btn-save {
    background-color: var(--btn-primary-bg-color);
    color: var(--btn-primary-text-color);
}

#btn-save:hover {
    background-color: var(--btn-primary-bg-color-hover);
    color: var(--btn-primary-text-color);
}
.is-size-5_5{
    font-size: 1.1rem;
}
</style>
